import { useEffect, useRef, useState } from 'react';
import TableList from '../TableList';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrderInfoByUPSOrderNumber, scanToRemove, scanWrongArea } from '../../../actions/utActions';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { Button, Grid, TextField, withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { getCurrentWarehouse } from '../../../utilities/common';
import { getExceptionByState } from '../../../actions/editOrderActions';
import ExceptionDialog from '../../EditOrderModal/NextTransition/ExceptionDialog';

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: '60%',
        marginBottom: 20
    },
}))(TextField);

function AreaWrong() {
    const dispatch = useDispatch();
    const {t} = useTranslation('updateToolbox');

    const orderListCurr = useSelector(state => state.updateToolbox.fetchOrderInfoByUpsOrderNumber);

    const [orderList, setOrderList] = useState([]);
    const [orderRegister, setOrderRegister] = useState('');
    const [orderRepair, setOrderRepair] = useState('');
    const [upsNo, setUpsNo] = useState('');
    
    const [successOpen, setSuccessOpen] = useState(false);
    const [failOpen, setFailOpen] = useState(false);
    const [upsFailOpen, setUpsFailOpen] = useState(false);
    const [openExceptionDialog, setOpenExceptionDialog] = useState(false);
    const [exceptionList, setExceptionList] = useState([]);

    const exceptionId = useRef(null)


    const handleKeyPress = (event, type) => {
        if(event.key === 'Enter') {
            if(type === 1) {
                handleWrongArea();
            } else if(type === 2) {
                handleRemove();
            }
        }
    }
    const handleOrderRegister = (event) => {
        setOrderRegister(event.target.value);
    };
    const handleOrderRepair = (event) => {
        setOrderRepair(event.target.value);
    };
    const handleUPSNo = (event) => {
        setUpsNo(event.target.value);
    };

    function handleFetchOrderList() {
        dispatch(fetchOrderInfoByUPSOrderNumber(upsNo))
        .then(() => {
            dispatch(showAlertSnackbar({message: t('success_message'), type: 'success'}))
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('add_message'), type: 'error'}))
            setOrderList([]);
        })
    }
    function handleWrongArea() {
        let warehouse = getCurrentWarehouse()['name'];

        dispatch(scanWrongArea(orderRegister, upsNo, warehouse, exceptionId.current))
        .then(() => {
            dispatch(showAlertSnackbar({message: t('success_message'), type: 'success'}))
            setOrderRegister('');
            handleFetchOrderList();
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('fail_message'), type: 'error'}))
            setOrderRegister('');
            handleFetchOrderList();
        })
    }
    function handleRemove() {
        dispatch(scanToRemove(orderRepair, upsNo))
        .then(() => {
            dispatch(showAlertSnackbar({message: t('success_message'), type: 'success'}))
            setOrderRepair('');
            handleFetchOrderList();
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('fail_message'), type: 'error'}))
            setOrderRepair('');
            handleFetchOrderList();
        })
    }

    function handleSubmit(){
        setOpenExceptionDialog(true);
        return
    }

    useEffect(() => {
        dispatch(getExceptionByState(219))
            .then((res) => {
                setExceptionList(res)
        })

        if(orderListCurr) {
            setOrderList(orderListCurr);
        }
    }, [orderListCurr])

    return (
        <>
            <div>
                <Grid container justifyContent="center" spacing={4}>
                    <Grid 
                        item 
                        xs={4}
                        style={{
                            display: 'flex',
                            alignItems: 'baseline'
                        }}
                    >
                        <FixedTextField
                            variant='outlined'
                            placeholder={t('input_ups_no')}
                            onChange={handleUPSNo}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginLeft: 10 }}
                            onClick={handleFetchOrderList}
                        >
                            {t('obtain_order_list')}
                        </Button>
                    </Grid>
                    <Grid 
                        item 
                        xs={4}
                        style={{
                            display: 'flex',
                            alignItems: 'baseline'
                        }}
                    >
                        <FixedTextField
                            variant='outlined'
                            placeholder={t('input_order_no')}
                            onChange={handleOrderRegister}
                            onKeyPress={(e)=>handleKeyPress(e, 1)}
                            value={orderRegister}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginLeft: 10 }}
                            disabled={!orderRegister || !upsNo}
                            onClick={handleSubmit}
                        >
                            {t('register_wrong_area')}
                        </Button>
                    </Grid>
                    <Grid 
                        item 
                        xs={4}
                        style={{
                            display: 'flex',
                            alignItems: 'baseline'
                        }}
                    >
                        <FixedTextField
                            variant='outlined'
                            placeholder={t('input_order_no')}
                            onChange={handleOrderRepair}
                            value={orderRepair}
                            onKeyPress={(e)=>handleKeyPress(e, 2)}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginLeft: 10 }}
                            disabled={!orderRepair || !upsNo}
                            onClick={handleRemove}
                        >
                            {t('repair_wrong_area')}
                        </Button>
                    </Grid>
                </Grid>
            </div>
            <div>
                <TableList orderList={orderList}/>
            </div>
            <ExceptionDialog
                exceptions={exceptionList}
                open={openExceptionDialog}
                onClose={()=>{
                    setOpenExceptionDialog(false)
                }}
                onFinish={(value)=>{
                    exceptionId.current = value
                    handleWrongArea()
                }}
            />
        </>
    );
}

export default AreaWrong;